module.exports = __webpack_public_path__ + "static/media/phones.9c545576.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/phones.png
// module id = 247
// module chunks = 0